import React from "react";

// This component renders a floating button on mobile to toggle map view
const MobileMapToggle = ({ isMapVisible, toggleMapView, totalResults }) => {
  // Only show on mobile devices
  if (window.innerWidth >= 1024) {
    return null;
  }

  return (
    <div className="map-toggle-container">
      <button
        className="map-toggle-button"
        onClick={toggleMapView}
        aria-label={isMapVisible ? "Show List" : "Show Map"}
      >
        {isMapVisible ? (
          // List icon when map is visible
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="8" y1="6" x2="21" y2="6"></line>
            <line x1="8" y1="12" x2="21" y2="12"></line>
            <line x1="8" y1="18" x2="21" y2="18"></line>
            <line x1="3" y1="6" x2="3.01" y2="6"></line>
            <line x1="3" y1="12" x2="3.01" y2="12"></line>
            <line x1="3" y1="18" x2="3.01" y2="18"></line>
          </svg>
        ) : (
          // Map icon when list is showing
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"></polygon>
            <line x1="8" y1="2" x2="8" y2="18"></line>
            <line x1="16" y1="6" x2="16" y2="22"></line>
          </svg>
        )}
      </button>
    </div>
  );
};

export default MobileMapToggle;
